<div class="content">

    <div class="content__header">
        Forgot your password
        <ds-icon name="cross" color="#313131" [size]="18" (click)="onClose()"></ds-icon>
    </div>

    <div class="content__description">
        Enter your Practice ID and username to reset your password.
    </div>

    <div class="content__error" *ngIf="activeError">
        <ds-icon name="warn" color="red" [size]="21"></ds-icon>
        <ng-container [ngSwitch]="activeError">
            <ng-container *ngSwitchCase="authErrorService.errors.UserNotValid">
                Invalid username. Please try again.
            </ng-container>
            <ng-container *ngSwitchCase="authErrorService.errors.PracticeNotValid">
                We can't find that Practice ID. Contact your practice administrator and try again.
            </ng-container>
            <ng-container *ngSwitchDefault>
                Something went wrong. Please try again later.
            </ng-container>
        </ng-container>
    </div>

    <div class="content__body">
        <form autocomplete="off" [formGroup]="formGroup" (ngSubmit)="onPasswordSubmit()">
            <input autocomplete="false" name="hidden" type="text" style="display:none;">
            <div class="formfield">
                <div class="formfield__label">

                    <label for="practiceId">
                        Practice ID
                    </label>
                    <span class="formfield__label__error"
                        *ngIf="formGroup.controls['practiceId'].touched && formGroup.controls['practiceId'].errors">
                        Required
                    </span>

                </div>
                <div class="formfield__control">
                    
                    <input #practiceIdInput 
                        autofocus="true" 
                        id="practiceIdInput" 
                        class="input-control" 
                        placeholder="Practice ID" 
                        formControlName="practiceId"
                        autocomplete="practiceId" 
                        [ngClass]="{ 'input-touched': formGroup.controls['practiceId'].touched && !formGroup.controls['practiceId'].value }"
                    >

                </div>
            </div>

            <div class="formfield">
                <div class="formfield__label">

                    <label for="user">
                        Username
                    </label>
                    <span *ngIf="formGroup.controls['user'].touched && formGroup.controls['user'].errors">
                        Required
                    </span>

                </div>

                <div class="formfield__control">
                    
                    <input #userInput 
                        autofocus="true" 
                        id="userInput" 
                        class="input-control" 
                        placeholder="Username" 
                        formControlName="user"
                        autocomplete="user" 
                        [ngClass]="{ 'input-touched': formGroup.controls['user'].touched && !formGroup.controls['user'].value }"
                    >

                </div>
            </div>

            <button 
                type="submit" 
                class="button-submit" 
                [disabled]="!formGroup.valid"
                [ngClass]="{ 'disabled-button': !formGroup.valid}"
            >
                Reset Password
            </button>

        </form>

    </div>
</div>

<pn-spinner [color]="'#FFFFFF;'" [visible]="isLoading" name="reset_password_spinner"></pn-spinner>

